import React from 'react';
import PropTypes from 'prop-types';

import css from './CustomFilterModal.scss';


const SUMMARY_NAME_LIMIT = 15;

const CustomSummarySection = ({ name, description, defaultFilter, onNameChange, onDescriptionChange, onDefaultFilterChange }) => (
  <div className={css.summarySection}>
    <h3 className={css.summaryTitle}>Custom Summary</h3>
    <label className={css.summaryLabel} htmlFor="customFilterSummaryName">{`Summary Name (Limit ${SUMMARY_NAME_LIMIT} Characters)`}</label>
    <input
      id="customFilterSummaryName"
      type="text"
      className={css.summaryInput}
      value={name || ''}
      maxLength={SUMMARY_NAME_LIMIT}
      onChange={ev => onNameChange(ev.target.value)}
    />
    <div className={css.summaryHint}>{`${Math.max(SUMMARY_NAME_LIMIT - (name || '').length, 0)} Characters Remaining`}</div>
    <label className={css.summaryLabel} htmlFor="customFilterSummaryDescription">Summary Description</label>
    <textarea
      id="customFilterSummaryDescription"
      className={css.summaryTextarea}
      placeholder="Enter a description here (optional)"
      value={description || ''}
      rows={3}
      onChange={ev => onDescriptionChange(ev.target.value)}
    />
    <label className={css.summaryCheckbox} htmlFor="customFilterDefaultFilter">
      <input
        id="customFilterDefaultFilter"
        type="checkbox"
        checked={!!defaultFilter}
        onChange={ev => onDefaultFilterChange(ev.target.checked)}
      />
      <span>Use as the default for all groups</span>
    </label>
  </div>
);

CustomSummarySection.propTypes = {
  name: PropTypes.string,
  description: PropTypes.string,
  defaultFilter: PropTypes.bool,
  onNameChange: PropTypes.func.isRequired,
  onDescriptionChange: PropTypes.func.isRequired,
  onDefaultFilterChange: PropTypes.func.isRequired,
};

export default CustomSummarySection;
